import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_ANALYTICS_API_URL || 'https://prvqnz3u69.execute-api.us-east-2.amazonaws.com/prod/analytics';

class AnalyticsApiService {
  async getAuthHeaders() {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      if (!token) {
        throw new Error('No authentication token available');
      }

      return {
        'Content-Type': 'application/json',
        'Authorization': token
      };
    } catch (error) {
      console.error('Failed to get auth headers:', error);
      throw new Error('Authentication required');
    }
  }

  async fetchAllCharts() {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.get(API_BASE_URL, { headers });
      if (response.data && response.data.success) {
        return response.data.charts || [];
      }
      return [];
    } catch (error) {
      console.error('Failed to fetch analytics from API:', error);
      return [];
    }
  }

  async fetchChart(chartType) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.get(`${API_BASE_URL}/${encodeURIComponent(chartType)}`, { headers });
      if (response.data && response.data.success) {
        return response.data.chart || null;
      }
      return null;
    } catch (error) {
      console.error(`Failed to fetch ${chartType} from API:`, error);
      return null;
    }
  }

  async saveChart(chartType, data) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.put(
        `${API_BASE_URL}/${encodeURIComponent(chartType)}`,
        { data },
        { headers }
      );
      if (response.data && response.data.success) {
        return response.data.chart;
      }
      return null;
    } catch (error) {
      console.error(`Failed to save ${chartType} to API:`, error);
      return null;
    }
  }

  async deleteChart(chartType) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.delete(
        `${API_BASE_URL}/${encodeURIComponent(chartType)}`,
        { headers }
      );
      return response.data && response.data.success;
    } catch (error) {
      console.error(`Failed to delete ${chartType} from API:`, error);
      return false;
    }
  }
}

export const analyticsApiService = new AnalyticsApiService();
export default analyticsApiService;
